import script from "./ReminderDefinitionList.vue?vue&type=script&setup=true&lang=js"
export * from "./ReminderDefinitionList.vue?vue&type=script&setup=true&lang=js"

import "./ReminderDefinitionList.vue?vue&type=style&index=0&id=bc8106a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc8106a2"]])

export default __exports__